import axios from 'axios'

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)


const commissionService = {


  async getAgentCommission(page = 1, limit = 10) {
    try {
      const response = await api.get(`/commission/get-agent-commissions`, {
        params: {
          page,
          limit
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      throw error;
    }
  },

  async getExperienceCommission(page = 1, limit = 10) {
    try {
      const response = await api.get(`/commission/get-experience-commissions`, {
        params: {
          page,
          limit
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error getting experience commissions:', error);
      throw error;
    }
  },

}

export default commissionService


export const {
  getAgentCommission,
  getExperienceCommission
} = commissionService